import React from "react";
import { i18n } from "~/i18n.js";

export function HeightValue({ value = 0 }) {
    const height_unit = i18n.height_unit
    const _value = parseInt(i18n.convertHeightToLocale(value)).toLocaleString(i18n.locale)
    return <div className="HeightValue">{_value || '-'} {height_unit === 'm' ? 'm' : 'ft'}</div>
}